var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwardTrophyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0367 22.9424C25.4348 24.1594 24.1946 24.9297 22.8368 24.9297C21.4791 24.9297 20.2389 24.1594 19.637 22.9424V29.0606H26.0367V22.9424Z",
    fill: "#FDD56F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6239 23.7769L24.0711 26.917C23.5656 27.9391 22.108 27.9391 21.6026 26.917L20.0497 23.7769L16.5708 24.5401L20.1924 36.6729H25.4812L29.1027 24.5402L25.6239 23.7769Z",
    fill: "#FAB85F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5498 24.0399L20.0498 23.777L18.3648 20.3696H15.3259L16.5709 24.5403C16.8127 24.5778 17.0583 24.5981 17.3066 24.5981C18.0795 24.5982 18.8552 24.4051 19.5498 24.0399Z",
    fill: "#FC945A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.309 20.3696L25.624 23.7771L26.1241 24.04C26.8186 24.4051 27.5941 24.5981 28.3669 24.5982C28.6157 24.5982 28.8612 24.5779 29.1029 24.5404L30.3479 20.3696H27.309Z",
    fill: "#FC945A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7217 33.9189L26.9678 44.9346H32.4756V33.9189H29.7217Z",
    fill: "#373E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7217 33.9189H13.1982V44.9346H29.7217V40.8037L28.3447 38.7383L29.7217 36.6729V33.9189Z",
    fill: "#51577D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9678 36.6729L25.5908 38.7383L26.9678 40.8037H29.7217V36.6729H26.9678Z",
    fill: "#FAB85F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9678 36.6729H15.9521V40.8037H26.9678V36.6729Z",
    fill: "#FDD56F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7217 36.6729H15.9521V40.8037H29.7217V36.6729Z",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4756 43.5576H29.7217L32.4756 46.3115H35.2295C35.2295 44.7905 33.9966 43.5576 32.4756 43.5576Z",
    fill: "#51577D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7217 43.5576H13.1982C11.6774 43.5576 10.4443 44.7905 10.4443 46.3115C10.4443 46.3115 26.0188 46.3115 32.4756 46.3115C32.4756 44.7905 31.2427 43.5576 29.7217 43.5576Z",
    fill: "#696E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5304 14.3371L33.227 10.7338C34.4529 9.53889 33.7764 7.45703 32.0823 7.21083L28.6488 6.71191L24.3352 19.9879L27.4063 21.6024C28.9216 22.399 30.6925 21.1123 30.4031 19.425L29.5304 14.3371Z",
    fill: "#FDD56F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6488 6.71196L26.9738 6.46851L24.6894 1.84002C23.9316 0.304628 21.7423 0.304628 20.9845 1.84002L18.7001 6.4686L13.5923 7.21078C11.8979 7.45698 11.2213 9.53921 12.4474 10.7343L16.1435 14.3371L15.2709 19.4244C14.9815 21.1119 16.7527 22.3988 18.2683 21.6021L22.8369 19.2003L24.3352 19.9879C25.8504 20.7845 27.6214 19.4978 27.332 17.8106L26.8161 14.8028C26.6628 13.9094 26.959 12.9978 27.6081 12.3652L29.7934 10.2349C31.0193 9.04002 30.3429 6.95816 28.6488 6.71196Z",
    fill: "#FFF07E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4756 43.5576V33.9189H13.1982V43.5576",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4756 43.5576H13.1982C11.6774 43.5576 10.4443 44.7905 10.4443 46.3115H35.2295C35.2295 44.7905 33.9966 43.5576 32.4756 43.5576Z",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8286 21.3076L21.6026 26.9171C22.1081 27.9392 23.5657 27.9392 24.0712 26.9171L26.8452 21.3076",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.637 22.9424C20.2388 24.1594 21.4791 24.9297 22.8368 24.9297C24.1946 24.9297 25.4348 24.1594 26.0367 22.9424",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3259 20.3696L19.3705 33.9192",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 7.06886L13.5923 7.21087C11.8979 7.45707 11.2213 9.5393 12.4474 10.7344L16.1435 14.3372L15.2709 19.4244C14.9815 21.112 16.7527 22.3989 18.2683 21.6021L22.8368 19.2003L27.4055 21.6021C28.921 22.3989 30.6923 21.112 30.4028 19.4244L29.5303 14.3372L33.2264 10.7344C34.4525 9.5393 33.7759 7.45707 32.0815 7.21087L26.9737 6.4687L24.6893 1.84002C23.9315 0.304628 21.7422 0.304628 20.9844 1.84002L18.7 6.4686L17.2944 6.67285",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3478 20.3696L28.5583 26.3644",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7707 29.0029L26.3032 33.9189",
    stroke: "black",
    strokeWidth: 1.52228,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_3489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardTrophyIcon);
export default __webpack_public_path__ + "static/media/award-trophy-icon.2646e482dbdba29e91495778c9a315aa.svg";
export { ForwardRef as ReactComponent };